module.exports = __webpack_public_path__ + "img/744.c847b51b.jpg";